import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorThumbsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M7.95 9.9a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0V10.65a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M10.406 2.714a.75.75 0 0 1 .694-.464c2.209 0 3.21 1.501 3.428 2.368.014.06.022.12.022.182v3.75h4.27a2.55 2.55 0 0 1 2.505 3.032l-1.417 7.37a3.45 3.45 0 0 1-3.388 2.798H5.7a3.45 3.45 0 0 1-3.45-3.45v-4.95A3.45 3.45 0 0 1 5.7 9.9h1.748l2.958-7.186Zm1.18 1.076-2.942 7.146a.75.75 0 0 1-.694.464H5.7a1.95 1.95 0 0 0-1.95 1.95v4.95a1.95 1.95 0 0 0 1.95 1.95h10.82a1.95 1.95 0 0 0 1.915-1.582l1.417-7.37a1.05 1.05 0 0 0-1.031-1.248H13.8a.75.75 0 0 1-.75-.75V4.908c-.114-.325-.518-.953-1.464-1.118Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorThumbsUp;
